import React, { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import * as S from './HoldTightModal.styled';

type Props = {
    open: boolean;
    closeModal: () => void;
    boomConfetti: (arg: boolean) => void;
};

const HoldTightModal = ({ open, closeModal, boomConfetti }: Props) => {
    const [progressWidth, setProgressWidth] = useState<string>('0%');
    const [gifLoaded, setGifLoaded] = useState<boolean>(false);

    useEffect(() => {
        if (gifLoaded) {
            const animationDuration = 2000;
            const interval = 100;

            const startTime = Date.now();

            const animationInterval = setInterval(() => {
                const elapsedTime = Date.now() - startTime;

                if (elapsedTime < 1000) {
                    setProgressWidth('0%');
                }
                if (elapsedTime < 1800) {
                    setProgressWidth('70%');
                } else {
                    setProgressWidth('100%');
                }

                if (elapsedTime >= animationDuration) {
                    clearInterval(animationInterval);
                    boomConfetti(true);
                    closeModal();
                }
            }, interval);

            return () => {
                clearInterval(animationInterval);
            };
        }
        // eslint-disable-next-line
    }, [gifLoaded]);

    return (
        <Modal open={open}>
            <S.ModalWrapper>
                <S.Modal style={{ display: gifLoaded ? 'flex' : 'none' }}>
                    <S.Prompt>Hold Tight, Your results are being processed!</S.Prompt>
                    <S.HoldTightGif
                        src={process.env.PUBLIC_URL + '/HoldTight.gif'}
                        alt="Hold Tight GIF"
                        onLoad={() => setGifLoaded(true)}
                    />
                    <div>
                        <S.ProgressBarContainer>
                            <S.ProgressBar width={progressWidth} />
                        </S.ProgressBarContainer>
                        <S.CompletedText>
                            <S.GreenText>{progressWidth}</S.GreenText> completed
                        </S.CompletedText>
                    </div>
                </S.Modal>
            </S.ModalWrapper>
        </Modal>
    );
};

export default HoldTightModal;
